import React from "react";
import { alpha } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import MuiCard from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AppTheme from "../shared-theme/AppTheme";

const projects = [
  {
    key: "vendai",
    title: "VendAI",
    description: "Vending AI Platform",
    url: "https://vendai.lettaiot.com/login",
  },
  {
    key: "vendbox",
    title: "VendBox",
    description: "Vending Operations",
    url: "https://vendbox.lettaiot.com/login",
  },
  {
    key: "wwms",
    title: "WWMS",
    description: "Water Wastage Management System",
    url: "https://wwms.lettaiot.com/login",
  },
  {
    key: "lettaiot",
    title: "Letta IoT",
    description: "IoT Management",
    url: "https://lettaiot.com/login",
  },
];

// no-op

export default function ProjectList(props) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <Box
        component="main"
        sx={(theme) => ({
          minHeight: "100dvh",
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
          overflow: "auto",
        })}
      >
        <Stack
          spacing={2}
          sx={{
            alignItems: "center",
            mx: 3,
            pb: 6,
            pt: { xs: 8, md: 10 },
          }}
        >
          <MuiCard
            variant="outlined"
            sx={{ width: "100%", maxWidth: 1000, p: { xs: 2, sm: 3 } }}
          >
            <Typography variant="h4" component="h1" gutterBottom>
              Projects
            </Typography>
            {/* <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{ mb: 3 }}
            >
              Choose a project to continue
            </Typography> */}
            <CardContent sx={{ px: { xs: 1, sm: 2 }, pt: 0 }}>
              <List disablePadding>
                {projects.map((p, idx) => (
                  <React.Fragment key={p.key}>
                    <ListItem disablePadding>
                      <ListItemButton
                        component="a"
                        href={p.url}
                        sx={{ py: 1.25 }}
                      >
                        <ListItemText
                          primary={
                            <Typography variant="subtitle1" fontWeight={600}>
                              {p.title}
                            </Typography>
                          }
                          secondary={
                            <>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {p.description}
                              </Typography>
                              <Typography variant="caption" color="primary">
                                {p.url}
                              </Typography>
                            </>
                          }
                        />
                        <ChevronRightIcon color="action" />
                      </ListItemButton>
                    </ListItem>
                    {idx !== projects.length - 1 && <Divider component="li" />}
                  </React.Fragment>
                ))}
              </List>
            </CardContent>
          </MuiCard>
        </Stack>
      </Box>
    </AppTheme>
  );
}
